import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RadioButtonModule} from 'primeng/radiobutton';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {QueryBuilderComponent} from '@ispm-client/modules/query-builder/query-builder.component/query-builder.component';
import {PanelModule} from 'primeng/panel';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {QueryParameterComponent} from '@ispm-client/modules/query-builder/query-parameter.component/query-parameter.component';
import {SharedModule} from '@ispm/shared/shared.module';
import {WidgetsModule} from '@ispm/widgets/widgets.module';

@NgModule({
  imports: [
    SharedModule,
    WidgetsModule,
    RadioButtonModule,
    FormsModule,
    PanelModule,
    ToggleButtonModule,
    ReactiveFormsModule,
    DynamicFormModule
  ],
  declarations: [QueryBuilderComponent, QueryParameterComponent],
  exports: [QueryBuilderComponent, QueryParameterComponent],
  providers: []
})
export class QueryBuilderModule {
}
